var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarcopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7772 6.60352H0.894531C0.618531 6.60352 0.394531 6.37952 0.394531 6.10352C0.394531 5.82752 0.618531 5.60352 0.894531 5.60352H12.7772C13.0532 5.60352 13.2772 5.82752 13.2772 6.10352C13.2772 6.37952 13.0532 6.60352 12.7772 6.60352Z",
    fill: "#666E7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.80052 9.20703C9.52452 9.20703 9.29785 8.98303 9.29785 8.70703C9.29785 8.43103 9.51852 8.20703 9.79452 8.20703H9.80052C10.0765 8.20703 10.3005 8.43103 10.3005 8.70703C10.3005 8.98303 10.0765 9.20703 9.80052 9.20703Z",
    fill: "#666E7D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.84251 9.20703C6.56651 9.20703 6.33984 8.98303 6.33984 8.70703C6.33984 8.43103 6.56051 8.20703 6.83651 8.20703H6.84251C7.11851 8.20703 7.34251 8.43103 7.34251 8.70703C7.34251 8.98303 7.11851 9.20703 6.84251 9.20703Z",
    fill: "#666E7D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.87736 9.20703C3.60136 9.20703 3.37402 8.98303 3.37402 8.70703C3.37402 8.43103 3.59536 8.20703 3.87136 8.20703H3.87736C4.15336 8.20703 4.37736 8.43103 4.37736 8.70703C4.37736 8.98303 4.15336 9.20703 3.87736 9.20703Z",
    fill: "#666E7D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.80052 11.7979C9.52452 11.7979 9.29785 11.5739 9.29785 11.2979C9.29785 11.0219 9.51852 10.7979 9.79452 10.7979H9.80052C10.0765 10.7979 10.3005 11.0219 10.3005 11.2979C10.3005 11.5739 10.0765 11.7979 9.80052 11.7979Z",
    fill: "#666E7D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.84251 11.7979C6.56651 11.7979 6.33984 11.5739 6.33984 11.2979C6.33984 11.0219 6.56051 10.7979 6.83651 10.7979H6.84251C7.11851 10.7979 7.34251 11.0219 7.34251 11.2979C7.34251 11.5739 7.11851 11.7979 6.84251 11.7979Z",
    fill: "#666E7D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.87736 11.7979C3.60136 11.7979 3.37402 11.5739 3.37402 11.2979C3.37402 11.0219 3.59536 10.7979 3.87136 10.7979H3.87736C4.15336 10.7979 4.37736 11.0219 4.37736 11.2979C4.37736 11.5739 4.15336 11.7979 3.87736 11.7979Z",
    fill: "#666E7D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.52832 3.86099C9.25232 3.86099 9.02832 3.63699 9.02832 3.36099V1.16699C9.02832 0.890992 9.25232 0.666992 9.52832 0.666992C9.80432 0.666992 10.0283 0.890992 10.0283 1.16699V3.36099C10.0283 3.63699 9.80432 3.86099 9.52832 3.86099Z",
    fill: "#666E7D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.14355 3.86099C3.86755 3.86099 3.64355 3.63699 3.64355 3.36099V1.16699C3.64355 0.890992 3.86755 0.666992 4.14355 0.666992C4.41955 0.666992 4.64355 0.890992 4.64355 1.16699V3.36099C4.64355 3.63699 4.41955 3.86099 4.14355 3.86099Z",
    fill: "#666E7D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2810_3695",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 14,
    height: 14
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333008 1.71973H13.333V15.0003H0.333008V1.71973Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2810_3695)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.01367 2.71973C2.28501 2.71973 1.33301 3.64173 1.33301 5.31573V11.3484C1.33301 13.0591 2.28501 14.0004 4.01367 14.0004H9.65234C11.381 14.0004 12.333 13.0764 12.333 11.3991V5.31573C12.3357 4.49239 12.1143 3.85239 11.675 3.41239C11.223 2.95906 10.5263 2.71973 9.65834 2.71973H4.01367ZM9.65234 15.0004H4.01367C1.74367 15.0004 0.333008 13.6011 0.333008 11.3484V5.31573C0.333008 3.09706 1.74367 1.71973 4.01367 1.71973H9.65834C10.7977 1.71973 11.7397 2.06106 12.383 2.70573C13.0077 3.33306 13.3363 4.23506 13.333 5.31706V11.3991C13.333 13.6204 11.9223 15.0004 9.65234 15.0004Z",
    fill: "#666E7D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarcopy);
export default __webpack_public_path__ + "static/media/Calendar copy.c1e1af3e8370ef2ae474038d17d0ed4d.svg";
export { ForwardRef as ReactComponent };